module.exports = __webpack_public_path__ + "static/media/image2.8f8916a0.jpg";